import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when an office clicks the "Continue" button on the
 * "Select a Professional Type" popup
 * Event: dental_portal:shift_request:professional_type_selected
 */
export function fireProfessionalTypeSelected(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:professional_type_selected', {
    version: 202603,
  });
}
